import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import ItchIoLogo from "../assets/logos/itchio-logo-textless-white.png";
import InfiniteCarousel from "../components/InfiniteCarousel";
import UCILogo from "../assets/logos/UCI.png";
import Everlaw from "../assets/thumbnails/everlaw.jpg";
import scribe from "../assets/thumbnails/scribe/Full.webm";
import partyify from "../assets/thumbnails/Partyify1.mp4";
import proceduraltree from "../assets/thumbnails/Proceduraltree.mp4";
import musicalMadness from "../assets/thumbnails/musicalmadness2.mp4";
import toonShader from "../assets/thumbnails/toonshader.mp4";
import jokeBrowser from "../assets/thumbnails/JokeBrowser.gif";
import wartorn from "../assets/thumbnails/WartornShader.mp4";
import capstone from "../assets/thumbnails/capstoneArchive.mp4";
import { MediaRenderer } from "../components/MediaRenderer";
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
// ✨ remove the target: containerRef — use global scroll instead

const BentoCell = ({ children, className }) => {
  return (
    <div
      className={
        "h-full w-full shadow-md   rounded-lg duration-300 " + className
      }
    >
      {" "}
      {children}
    </div>
  );
};

const Bento = () => {
  const projectImages = [partyify, proceduraltree, musicalMadness, jokeBrowser];

  // 🔹 Ref for the Bento section (the part we want to track scroll on)
  const bentoRef = useRef(null);

  // 🔹 Track scroll progress only while Bento is in view
  const { scrollYProgress } = useScroll({
    target: bentoRef,
    offset: ["end end", "end start"], // maps 0–1 across the section
  });

  // 🔹 Animate from 0% → 100%
  const translateY = useTransform(scrollYProgress, [0, 0.9], ["0%", "-100%"]);

  return (
    <div
      ref={bentoRef}
      className=" min-h-[100vh] flex justify-center sporo bg-cover"
    >
      <div className="w-[min(90vw,1400px)] my-12 gap-3 grid grid-cols-12 grid-rows-7 ">
        <BentoCell className={"row-span-1 col-span-3 "}>
          <div className="flex justify-between h-full align-middle gap-2 ">
            <div className=" bg-blue-600 flex-1  p-4  rounded-md">
              <a
                href="https://www.linkedin.com/in/hung-bui-06ab67208/"
                target="_blank"
                className="text-white"
              >
                <FaLinkedin className="h-full w-full"></FaLinkedin>
              </a>
            </div>
            <div className=" bg-purple-600 flex-1  p-4  rounded-md">
              <a
                href="https://github.com/hungbuiwork/"
                target="_blank"
                className="text-white"
              >
                <FaGithub className="h-full w-full"></FaGithub>
              </a>
            </div>
            <div className=" bg-red-500 flex-1  p-4  flex items-center rounded-md">
              <a
                href="https://www.linkedin.com/in/hung-bui-06ab67208/"
                target="_blank"
                className="text-white "
              >
                <img src={ItchIoLogo} className=" aspect-square"></img>
              </a>
            </div>
          </div>
        </BentoCell>
        <BentoCell
          className={
            "row-span-2 col-span-3 bg-[#255799] border-blue-400 border-2 text-[#fecc07]  shadow-2xl shadow-blue-600 p-4 flex flex-col items-center justify-center"
          }
        >
          <h2 className="font-extrabold text-3xl">UC Irvine</h2>
          <p>2020 - 2024</p>
          <br></br>
          <img src={UCILogo} className="h-32"></img>
          <br />
          <p> B.S. in Computer Science</p>
          <p> B.S. in Game Design</p>
          <p>GPA 3.94 | Cum Laude</p>
        </BentoCell>
        <BentoCell
          className={
            "row-span-2 col-span-6 glass-bento p-4 flex flex-col justify-center gap-8 shadow-2xl shadow-emerald-400/50"
          }
        >
          <InfiniteCarousel className={"fade-edges py-2"}>
            <div className="flex gap-12">
              <Skill
                name="Python"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg"
              />
              <Skill
                name="C#"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/csharp/csharp-original.svg"
              />
              <Skill
                name="C++"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg"
              />
              <Skill
                name="JavaScript"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg"
              />
              <Skill
                name="TypeScript"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/typescript/typescript-original.svg"
              />
              <Skill
                name="HTML5"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg"
              />
              <Skill
                name="React"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg"
              />
              <Skill
                name="NextJS"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nextjs/nextjs-original.svg"
              />
              <Skill
                name="CSS"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg"
              />

              <Skill
                name="TailwindCSS"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/tailwindcss/tailwindcss-original.svg"
              />
              <Skill
                name="Fastapi"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/fastapi/fastapi-original.svg"
              />
            </div>
          </InfiniteCarousel>
          <InfiniteCarousel reverse={true} className={"fade-edges py-2"}>
            <div className="flex gap-12">
              <Skill
                name="Unity"
                className=""
                src="https://img.icons8.com/?size=2x&id=39848&format=png"
              />
              <Skill
                name="Unreal Engine"
                className=""
                src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/unrealengine/unrealengine-original-wordmark.svg"
              />

              <Skill
                name="Git"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-plain.svg"
              />
              <Skill
                name="Jira"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/jira/jira-original-wordmark.svg"
              />
              <Skill
                name="Trello"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/trello/trello-plain-wordmark.svg"
              />
              <Skill
                name="Canva"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/canva/canva-original.svg"
              />
              <Skill
                name="Figma"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg"
              />
            </div>
          </InfiniteCarousel>
        </BentoCell>
        <BentoCell
          className={
            "row-span-1 col-span-3 flex  justify-center glass-bento shadow-2xl shadow-blue-400/70"
          }
        >
          <div className="flex flex-col justify-center">
            <h3 className="text-lg font-bold">⚙️ Engineer by craft</h3>
            <h3 className=" text-lg font-bold">𓂃🖌 Artist at heart</h3>
          </div>
        </BentoCell>
        <BentoCell
          className={
            "row-span-3 col-span-3 me bg-cover bg-center border-white border-2"
          }
        ></BentoCell>
        <BentoCell
          className={
            "row-span-3 col-span-6 flex flex-col justify-center px-14 glass-bento shadow-2xl shadow-purple-400 "
          }
        >
          <h2 className="text-4xl font-extrabold ">Hung Bui</h2>
          <h3 className="leading-loose text-2xl">Software Engineer</h3>
          <p className="text-xl ">
            Hi! I’m a software engineer passionate about building impactful
            products and crafting beautiful, user-focused experiences through
            creative problem-solving.
          </p>
        </BentoCell>
        <BentoCell
          className={
            "row-span-3 relative col-span-3 bg-white items-center flex flex-col justify-center group overflow-hidden"
          }
        >
          Currently working at
          <img src={Everlaw} className="w-48"></img>
          <p className="">Everlaw</p>
          <p className=""></p>
          <div className="w-full h-full absolute  bg-white flex justify-center items-center px-4 left-full duration-300 ease-in-out group-hover:left-0">
            <p>
              Everlaw is a cloud-based legal platform that uses AI to streamline
              e-discovery and case preparation. As a Full Stack Engineer, I help
              build intelligent, end-to-end tools that empower legal teams to
              work faster and smarter.
            </p>
          </div>
        </BentoCell>
        <BentoCell className="row-span-2 overflow-hidden col-span-5 glass-bento border-2 relative">
          <h3 className="font-bold text-xl text-center  pt-8">Projects</h3>
          <div className=" h-full fade-edges-vertical mx-8  relative overflow-hidden">
            <motion.div
              style={{ y: translateY }}
              transition={{ type: "spring", stiffness: 100, damping: 20 }}
              className="flex flex-col absolute gap-4  justify-between  left-0 w-full"
            >
              {projectImages.map((img, index) => (
                <MediaRenderer
                  key={index}
                  src={img}
                  className=" rounded-xl  border-4"
                />
              ))}
            </motion.div>
          </div>
        </BentoCell>

        <BentoCell
          className={
            "row-span-2 group col-span-7 glass-bento  pt-0 relative overflow-hidden"
          }
        >
          <div className="p-6">
            <h3 className="font-bold text-xl text-center py-1">
              Featured Work - AI Medical Scribe
            </h3>
            <video
              className="rounded-lg"
              src={scribe}
              loop
              autoPlay
              playsInline
              muted
            ></video>
          </div>
          <div className="h-full w-full absolute duration-300 group-hover:bottom-0 bottom-full bg-white flex justify-center items-center  px-6 [text-shadow:none]">
            <p className="text-black">
              I built this AI scribe while working at Kern Vascular Center,
              working very closely with doctors and medical assistants to
              develop a HIPAA-compliant app which: generates concise medical
              notes based on speech alone, creates contextual and evidence-cited
              diagnosis recommendations and followup questions, leveraging AI
              powered real-time speech-to-text in over 30 different languages.
            </p>
          </div>
        </BentoCell>
      </div>
    </div>
  );
};

const Skill = ({ name, src, size = 80, className }) => {
  return (
    <div
      className={`flex flex-col items-center justify-center m-2 hover:scale-110 transition-transform duration-500 ${
        className || ""
      }`}
      style={{
        width: typeof size === "number" ? `${size}px` : size,
        height: typeof size === "number" ? `${size}px` : size,
      }}
    >
      {/* Icon / Image */}
      {src ? (
        <img
          alt={name}
          src={src}
          className="h-full w-full object-contain"
          draggable="false"
        />
      ) : (
        <div className="flex items-center justify-center h-full w-full">
          <h1 className="text-sm font-semibold">{name}</h1>
        </div>
      )}

      {/* Label underneath */}
      <p className="mt-2 text-xs font-medium text-white text-center select-none">
        {name}
      </p>
    </div>
  );
};

export default Bento;
